import { QuickFillTrayContext } from './context';
import { TrayContent } from './tray-content';

type Props = {
  closeModal: () => void;
};

export const QuickFillTrayContent = ({ closeModal }: Props) => {
  return (
    <QuickFillTrayContext.Provider value={{ closeModal }}>
      <TrayContent />
    </QuickFillTrayContext.Provider>
  );
};
